import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    event.preventDefault()
    const form = event.target
    const formData = new FormData(form)

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html, application/json'
      }
    })
    .then(response => {
      const contentType = response.headers.get('Content-Type')
      if (contentType && contentType.includes('application/json')) {
        return response.json().then(data => {
          if (data.success) {
            // Handle JSON success (fallback)
            const event = new CustomEvent('customer:created', {
              detail: { customer: data.customer }
            })
            document.dispatchEvent(event)
            this.closeModal()
            form.reset()
          } else {
            // Handle JSON errors
            const errorMessages = data.errors.join(', ')
            alert(`Failed to create customer: ${errorMessages}`)
          }
        })
      } else {
        // Handle Turbo Stream response
        return response.text().then(html => {
          const template = document.createElement('template')
          template.innerHTML = html
          const streams = template.content.querySelectorAll('turbo-stream')
          streams.forEach(stream => {
            document.body.appendChild(stream)
          })
        })
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('An error occurred while creating the customer')
    })
  }

  closeModal() {
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById('customerModal'),
      'modal'
    )
    if (modalController) {
      modalController.close()
    }
  }
}
